export default __webpack_public_path__ + "static/media/Guild.6ef02674.png";